import React, { useMemo } from "react";
import style from "./index.module.scss";
import { BaseQuestionType, viewPaperListItem } from "service/exercise";
import TopicReview from "../TopicReview";

interface TopicReviewProps {
    data: viewPaperListItem;
    checked: boolean;
    exerciseId: string;
    studentNo: string;
    refreshData: () => void;
}

export default function TopicReviewType({
    data,
    checked,
    refreshData,
    exerciseId,
    studentNo
}: TopicReviewProps) {
    //多题干题型，筛选出主观题
    const subCurrentData = useMemo(() => {
        if (data.queTypeId > 5 && checked) {
            return data?.questions.filter(
                (item: viewPaperListItem) =>
                    item.queTypeId === BaseQuestionType.Subjective
            );
        }
        return data?.questions;
    }, [data, checked]);

    return (
        <div className={style.root}>
            {/* 单题干 */}
            {data.style === "1" && (
                <TopicReview
                    data={data}
                    index={data.index}
                    onOk={refreshData}
                    exerciseId={exerciseId}
                    studentNo={studentNo}
                />
            )}

            {/* 多题干 */}
            {data.style === "2" &&
                subCurrentData &&
                subCurrentData.length !== 0 && (
                    <div>
                        <div className={style.info}>
                            <em>{data.index}.</em>（{data.typeName}，
                            {data.score ? data.score : 0}分）
                        </div>

                        <div className={style.trunk}>
                            <div
                                className={style.title}
                                dangerouslySetInnerHTML={{
                                    __html: data.contentText
                                }}
                            />
                        </div>

                        {subCurrentData.map((item: viewPaperListItem) => (
                            <div className={style.item} key={item.id}>
                                <TopicReview
                                    data={item}
                                    index={`(${item.index})`}
                                    onOk={refreshData}
                                    exerciseId={exerciseId}
                                    studentNo={studentNo}
                                />
                            </div>
                        ))}
                    </div>
                )}
        </div>
    );
}
